// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__RiI10","footer":"ModalUpdate_footer__lMmN_"};